// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';

// shared-ui
import { ILocalization, withLocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { IndustryStore, UserStore, UserAuthStore, CountriesStore } from 'stores';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';

// components
import { SignupAHForm } from './signup-ah-form';
import { SignupAHConfirmation } from './signup-ah-confirmation';

interface SignupAHProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  industries?: IndustryStore;
  countriesStore?: CountriesStore;
  l10n?: ILocalization;
  routeStore?: RouteStore;
  user?: UserStore;
  userAuth?: UserAuthStore;
}

interface SignupAHState {
  showConfirmation: boolean;
  email: string;
  verificationEmailError: string;
  countries: Map<string, string>;
}

@withLocalization
@inject('analytics', 'industries', 'countriesStore', 'routeStore', 'user', 'context', 'userAuth')
export class SignupAH extends React.Component<SignupAHProps, SignupAHState> {
  public constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
      email: '',
      verificationEmailError: '',
      countries: new Map<string, string>(),
    };

    this.props.countriesStore.fetchForLocale(this.props.context.locale);
  }

  public componentDidMount() {
    this.setState({
      countries: this.props.countriesStore.countries,
    });
  }

  public componentDidUpdate() {
    if (this.props.routeStore.queryParams) {
      const { email } = this.props.routeStore.queryParams;
      const { showConfirmation } = this.state;
      if (email && !showConfirmation) {
        this.setState({
          showConfirmation: true,
          email,
        });
      }
    }
  }

  public onVerificationEmailError = () => {
    this.setState({
      verificationEmailError: 'Email communication failed. Please try again',
      countries: this.props.countriesStore.countries,
    });
  };

  public render() {
    const { showConfirmation, email, verificationEmailError, countries } = this.state;

    return (
      <>
        {showConfirmation ? (
          <UitkSpacing className="container--small-1" padding={{ block: 'twelve' }}>
            <main>
              <SignupAHConfirmation email={email} verificationEmailError={verificationEmailError} />
            </main>
          </UitkSpacing>
        ) : (
          <>
            <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
              <main>
                <UitkSpacing padding={{ blockend: 'six' }}>
                  <UitkHeading tag="h1" size={3}>
                    <LocalizedText message="signup.page.title" />
                  </UitkHeading>
                </UitkSpacing>
                <SignupAHForm onVerificationEmailError={this.onVerificationEmailError} countries={countries} />
              </main>
            </UitkSpacing>
          </>
        )}
      </>
    );
  }
}
